module.exports = __webpack_public_path__ + "static/media/flow-mobile.83256fcc.png";